var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIbDraftMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ib-draft-menu_svg__clip0_5999_26885)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#ED1B2E"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 4.853a2 2 0 012-2h12a2 2 0 012 2v16a2 2 0 01-2 2H6a2 2 0 01-2-2v-16zm14 0H6v16h12v-16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 12.852a1 1 0 011-1h6a1 1 0 010 2H9a1 1 0 01-1-1zM8 16.852a1 1 0 011-1h3a1 1 0 010 2H9a1 1 0 01-1-1zM8 8.853a1 1 0 011-1h6a1 1 0 110 2H9a1 1 0 01-1-1z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ib-draft-menu_svg__clip0_5999_26885"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(2 2.852)",
    d: "M0 0h20v20H0z"
  })))));
}

export default SvgIbDraftMenu;